import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '@/components/layout/Header';
import Footer from '@/components/layout/Footer';
import { XCircle } from 'lucide-react';
import { useTenant } from '@/contexts/TenantContext';

export default function CheckoutCancelPage() {
  const navigate = useNavigate();
  const { tenantPath } = useTenant();
  
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <div className="container mx-auto px-6 py-24">
        <div className="max-w-2xl mx-auto text-center">
          <XCircle className="h-16 w-16 text-[#EF4444] mx-auto mb-6" />
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Chivo, sans-serif' }}>
            Checkout Cancelled
          </h1>
          <p className="text-gray-600 text-lg mb-8">
            Your payment was cancelled. Your items are still in your cart.
          </p>
          <div className="flex items-center justify-center space-x-4">
            <button
              onClick={() => navigate(tenantPath('/cart'))}
              className="h-12 px-8 bg-[#334155] text-white font-bold uppercase tracking-wider rounded-lg hover:bg-[#475569] transition-all"
            >
              Return to Cart
            </button>
            <button
              onClick={() => navigate(tenantPath('/'))}
              className="h-12 px-8 bg-transparent border border-[#F3F4F6] text-gray-900 font-bold uppercase tracking-wider rounded-lg hover:border-[#334155] hover:text-[#334155] transition-all"
            >
              Continue Shopping
            </button>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
}
